<div class="atrizult-map-wrapper">
  <div class="title-heading-wrapper">
    <h1>{{ "contact-page.mapTitle" | translate }}</h1>
    <p class="map-sub-heading">{{ "contact-page.mapSubtitle" | translate }}</p>
  </div>
  <div class="atrizult-map-box">
    <div id="atrizult-map"></div>
  </div>
  <div class="atrizult-map-bottom-text" (click)="onClickAddress('ng')">
    <img src="assets/svgs/icons/location-black.svg" alt="location-icon" />
    <div>
      <p>{{ "contact-page.addressTitle.ng" | translate }}</p>
      <p>65 Chime Ave, New Haven, Enugu 400221, Enugu</p>
    </div>
  </div>
  <div class="atrizult-map-bottom-text" (click)="onClickAddress('de')">
    <img src="assets/svgs/icons/location-black.svg" alt="location-icon" />
    <div>
      <p>{{ "contact-page.addressTitle.de" | translate }}</p>
      <p>Steilshooper Straße 210, 22307 Hamburg, Germany</p>
    </div>
  </div>
</div>
